<template>
  <a-modal
    :visible="exportVisible"
    :title="title"
    width="600px"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
    :maskClosable="false"
    :bodyStyle="{ padding: '0px' }"
  >
    <a-form :form="form" class="headForm" :label-col="labelCol">
      <a-form-item label="报表类型">
        <span style="font-size: 12px">{{ nameList[exportKey] }}</span>
      </a-form-item>
      <a-form-item label="价格来源" v-if="exportKey === 0 || exportKey == 3 || exportKey == 4">
        <a-checkbox-group
          v-decorator="[
            'priceList',
            { rules: [{ required: true, message: '请选择价格来源' }] },
          ]"
          style="width: 100%"
        >
          <a-checkbox
            v-for="el in priceSource"
            :key="el.code"
            :value="el.code"
            >{{ el.name }}</a-checkbox
          >
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="文件名">
        <a-input
          v-decorator="[
            'fileName',
            {
              rules: [
                { required: true, message: '请输入' },
                { validator: validatorName, trigger: 'change' },
              ],
            },
          ]"
          placeholder="请输入"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import moment from 'moment'

export default {
  props: ['exportVisible', 'exportKey', 'exportItem'],
  data() {
    return {
      nameLen: 40,
      form: this.$form.createForm(this),
      labelCol: { style: { width: '100px' } },
      nameList: ['产品配方报表', '产品生产报表', '产品成本报表', '产品对比报表', '配方对比报表'],
      priceSource: [
        { name: '市场价格', code: 4 }, { name: '库存价格', code: 3 }, { name: '合同价格', code: 1 }, { name: '预测价格', code: 2 },
      ]
    }
  },
  watch: {
    exportVisible(val) {
      if (val) setTimeout(() => {
        this.setName()
      }, 0);
    }
  },
  computed: {
    title() {
      let indexFlag = this.exportKey === 0 || this.exportKey === 3 || this.exportKey === 4
      let title = this.exportItem ? '导出' : '批量导出'
      let str = <p>{title}{indexFlag ? <span style={{ 'font-size': '10px', color: '#aaa', 'margin-left': '10px' }}>选择价格来源</span> : null}</p>
      return str
    },
  },
  methods: {
    setName() {
      let fileName = this.nameList[this.exportKey] + moment(new Date()).format('YYYYMMDDHHmm')
      this.form.setFieldsValue({ fileName })
    },
    validatorName(rule, value, callback) {
      let msg = ''
      // let reg2 = /[`/\\~!@$^&_+=<>?:"{}|^%,;'[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if (reg2.test(value)) {
        // msg = `文件名不能包含\`/\\~!@$^&_+=<>?:"{}|^%,;'[]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、等特殊字符`
        msg = '文件名不能包含*[]：？<>/、\\.等特殊字符'
      }
      let len = value.length
      if (len > this.nameLen) {
        msg = `文件名长度不能超过${this.nameLen}个字符`
      }
      if (msg) callback(new Error(msg))
      callback()
    },
    checkNameLen(rule, value, callback) {
      if (value && value.length > this.nameLen) {
        callback(new Error(`文件名长度不能超过${this.nameLen}个字符`))
      }
      callback()
    },
    ok() {
      this.form.validateFields((err, values) => {
        if (err) return
        let { priceList = [], fileName = undefined } = values || {}
        if (this.exportKey === 0 || this.exportKey === 3 || this.exportKey === 4) {
          if (priceList.length > 0 && fileName) {
            this.$emit('ok', { priceList, fileName });
          }
        } else {
          if (fileName) this.$emit('ok', { fileName });
        }
      })
      // this.$emit('exportPrice');
    },
    cancel() {
      this.$emit('closeExport')
    },
  }
}
</script>